import "./registerServiceWorker";

/**
 * Contive Unified
 *
 * F = Pessoa Física  -> interface pessoal (baseline v1.5)
 * J = Pessoa Jurídica -> interface empresarial (baseline v2.48)
 *
 * A ausência do cookie usa a interface pessoal, que contém login/cadastro.
 * Após a sessão ser validada, valid-session.js atualiza o account_type e
 * recarrega automaticamente se a interface ativa não corresponder à conta.
 */
function readCookie(name) {
  const target = name + "=";
  const parts = document.cookie ? document.cookie.split(";") : [];

  for (const rawPart of parts) {
    const part = rawPart.trim();
    if (part.indexOf(target) === 0) {
      try {
        return decodeURIComponent(part.substring(target.length));
      } catch (e) {
        return part.substring(target.length);
      }
    }
  }

  return null;
}

const accountType = readCookie("user_agive_account_type");
const publicTeamRoute = window.location.pathname.startsWith("/equipe/publico/ordem/");
// O fechamento público pertence ao Contive Empresas e precisa abrir mesmo sem cookie/sessão.
const variant = publicTeamRoute ? "business" : (accountType === "J" ? "business" : "personal");

window.__CONTIVE_APP_VARIANT__ = variant;
document.documentElement.setAttribute("data-contive-variant", variant);

if (variant === "business") {
  import(/* webpackChunkName: "contive-business" */ "./business/main.js");
} else {
  import(/* webpackChunkName: "contive-personal" */ "./personal/main.js");
}
